interface ValueLabel {
  value: string;
  label: string;
}

const statuses: ValueLabel[] = [
  { value: 'emitted', label: 'Emitido' },
  { value: 'printed', label: 'Impreso' },
  { value: 'canceled', label: 'Cancelado' },
];

function mapFromValueLabelList(list: ValueLabel[]): Map<string, string> {
  return new Map(list.map(({ value, label }) => [value, label]));
}

const statusesMap = mapFromValueLabelList(statuses);

export const cases = new Map([['status', statusesMap]]);
